// frontend/src/ui/botLabel.mjs — a bot's display name + its difficulty icon (spec E2 §3).
// Knows the old emoji names ("Bot 🙂" …) so tables and results from before the rename still read.
const BOTS = { 'Bot Łatwy': 'face_smile', 'Bot Średni': 'face_think', 'Bot Trudny': 'face_wow', 'Bot Mistrz': 'brain', Bot: 'robot' };
// Escaped on purpose: these are data (old saved names), not UI text — the no-emoji guard stays green.
const LEGACY = { 'Bot \u{1F642}': 'Bot Łatwy', 'Bot \u{1F914}': 'Bot Średni', 'Bot \u{1F62E}': 'Bot Trudny', 'Bot \u{1F9E0}': 'Bot Mistrz', 'Bot \u{1F916}': 'Bot' };
export function botLabel(name) {
  const text = LEGACY[String(name).replace(/️/g, '')] ?? name;
  return text in BOTS ? { text, icon: BOTS[text] } : null;
}
export const nameWithIcon = (name) => { const b = botLabel(name); return b ? `${b.text} {${b.icon}}` : name; };
